import partnerAction from './partnerAction';

export default {
  namespaced: true,
  state() {},
  getters: {},
  mutations: {},
  actions: partnerAction,
};
